import * as React from "react";

import { useMsal } from "@azure/msal-react";
import {
  Button,
  NavDivider,
  NavDrawer,
  NavDrawerBody,
  NavDrawerFooter,
  NavDrawerHeader,
  NavItem,
  Tooltip,
} from "@fluentui/react-components";
import {
  Dismiss20Regular,
  DocumentSearch20Filled,
  DocumentSearch20Regular,
  Key20Filled,
  Key20Regular,
  PersonCircle32Regular,
  SignOut20Filled,
  SignOut20Regular,
  bundleIcon,
} from "@fluentui/react-icons";
import { useNavigate } from "react-router-dom";

import { useStyles } from "./styles";

const SignOut = bundleIcon(SignOut20Filled, SignOut20Regular);
const Tokens = bundleIcon(Key20Filled, Key20Regular);
const Scan = bundleIcon(DocumentSearch20Filled, DocumentSearch20Regular);

export interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const styles = useStyles();
  const { accounts, instance } = useMsal();
  const userEmail = accounts[0]?.username || "";

  const navigateTo = (path: string) => () => {
    navigate(path);
    onClose();
  };

  const handleSignOut = async () => {
    try {
      await instance.logoutPopup({ account: accounts[0] });
    } catch (error) {
      console.error("Failed to sign out via logoutPopup:", error);
    } finally {
      onClose();
    }
  };

  return (
    <NavDrawer
      open={open}
      type="overlay"
      position="end"
      className={styles.drawer}
      onOpenChange={(_event, data) => {
        if (!data.open) onClose();
      }}
    >
      <NavDrawerHeader>
        <Tooltip content="Close menu" relationship="label">
          <Button
            appearance="subtle"
            icon={<Dismiss20Regular />}
            onClick={onClose}
            aria-label="Close menu"
          />
        </Tooltip>
      </NavDrawerHeader>

      <NavDrawerBody>
        <div className={styles.userInfo}>
          <PersonCircle32Regular />
          <span>{userEmail}</span>
        </div>

        <NavDivider className={styles.divider} />

        <NavItem icon={<Scan />} value="scan" onClick={navigateTo("/")}>
          Scan
        </NavItem>

        <NavItem icon={<Tokens />} value="tokens">
          Tokens
        </NavItem>
      </NavDrawerBody>

      <NavDrawerFooter>
        <NavDivider className={styles.divider} />

        <NavItem icon={<SignOut />} value="sign-out" onClick={handleSignOut}>
          Sign Out
        </NavItem>

        <span className={styles.copyright}>© 2026 Beyond Assured. All Rights Reserved.</span>
      </NavDrawerFooter>
    </NavDrawer>
  );
};

export default Sidebar;
